import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["price", "Price per Airbnb per month (USD)", 0.5], ["trial_days", "Free trial days", 1], ["grace_days", "Grace period (days)", 1],
  ["kh_per_property", "Key holders per Airbnb", 1], ["trial_keyholders", "Key holders during trial", 1],
  ["card_price", "NFC card price (UGX)", 500], ["keyholder_price", "Key holder price (UGX)", 500],
  ["delivery_kampala", "Delivery in Kampala & Entebbe (UGX)", 500], ["delivery_upcountry", "Courier upcountry (UGX)", 500],
];
const cls = "mt-1.5 h-10 w-full rounded-lg border border-[#302B28] bg-[#151312] px-3 text-sm text-white outline-none focus:ring-2 focus:ring-[#D96C4A]";

export default function Pricing() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/pricing").then((r) => setS((cur) => cur || r.data)); }, []);
  if (!s) return null;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, Number(s[k])]));
      const r = await api.put("/admin/pricing", { ...body, pay_instructions: s.pay_instructions });
      setS(r.data);
      toast.success("Pricing saved");
    } catch (e2) { toast.error(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} data-testid="admin-pricing-form">
      <h1 className="font-display text-3xl font-medium tracking-tight sm:text-4xl">Pricing settings</h1>
      <p className="mt-2 text-[#A39E9A]">Changes apply to every host straight away, including the landing page calculator.</p>
      <div className="mt-8 grid gap-4 rounded-2xl border border-[#302B28] bg-[#1E1A18] p-6 sm:grid-cols-2 lg:grid-cols-3">
        {FIELDS.map(([k, l, step]) => (
          <label key={k} className="text-sm text-[#A39E9A]">{l}<input type="number" min="0" step={step} value={s[k]} onChange={(e) => setS((x) => ({ ...x, [k]: e.target.value }))} className={cls} data-testid={`pricing-${k}-input`} /></label>
        ))}
        <label className="text-sm text-[#A39E9A] sm:col-span-2 lg:col-span-3">Payment instructions shown to hosts
          <textarea rows={4} value={s.pay_instructions} onChange={(e) => setS((x) => ({ ...x, pay_instructions: e.target.value }))} className={`${cls} h-auto py-2`} data-testid="pricing-instructions-input" placeholder="e.g. MTN MoMo 07xx xxx xxx (Hostkey Ltd)" />
        </label>
      </div>
      <button disabled={busy} className="mt-6 h-11 rounded-lg bg-[#D96C4A] px-6 font-semibold text-white hover:bg-[#C25D3E] disabled:opacity-60" data-testid="pricing-save-button">Save pricing</button>
    </form>
  );
}
